export default __webpack_public_path__ + "static/media/seven_content1.daa3abb4.png";